import React from 'react';
import { Grid, Typography } from "@material-ui/core/";

interface GuideProps {
    title: string;
    children: React.ReactNode;
}

export default function GuideComponent(props: GuideProps) {

    return (
        <Grid item sm={12}>

            <Grid>
                <Grid item sm={12}>
                    <Typography component="span">
                        {props.title}
                    </Typography>
                </Grid>

                <Grid item sm={12} component="span">
                    <Typography component="span">
                        <React.Fragment>
                            {props.children}
                        </React.Fragment>
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
}

